module.exports = __webpack_public_path__ + "static/media/background-ap.ce09f1e1.png";